import { useMutation } from "react-query";
import { UpdateCheckTimeAttendanceLog } from "services/workSchedule";

interface UpdateCheckTimePayload {
    data: any;
    id: number;
}

export default function useUpdateCheckTimeAttendanceLog() {
  return useMutation(({data, id}: UpdateCheckTimePayload) =>
    UpdateCheckTimeAttendanceLog(data, id)
  );
}
